import React from 'react';
import OuvrirFenetrePartenaireSansImg from '../../components/OuvrirFenetrePartenaireSansImg';
import OuvrirFenetrePartenaire from '../../components/OuvrirFenetrePartenaire';
import MagAgt from '../../images/MagAgt.jpg';

const MagnetsContent = () => {
    return (
        <div className="category-content">
            <h3 className="content-title">Magnets</h3>
            <div className="product-grid">
                <div className="product-item">
                    <h4>Magnets créés par l'Amicale</h4>
                    <img src={MagAgt} alt="Magnets Amicale" className="product-image2" />
                </div>
            </div>
            <div className="partner-section">
                <OuvrirFenetrePartenaireSansImg
                    sitePartenaire="https://association-au-coeur-de-troo.jimdosite.com"
                    texteBoutonPartenaire="Magnets : Coeur de Trôo"
                />
                <OuvrirFenetrePartenaire 
                    imageUrl="/ImgPartenaires/MagTT.jpg" 
                    sitePartenaire="https://association-au-coeur-de-troo.jimdosite.com"
                    classPartenaire='product-image2'
                    altPartenaire='Magnets Coeur de Troo'
                />
            </div>
        </div>
    );
};

export default MagnetsContent;
